import React from 'react';

export const useIsPrinting = (): boolean => {
  const [isPrinting, setIsPrinting] = React.useState<boolean>(false);

  const onBeforePrint = (): void => setIsPrinting(true);
  const onAfterPrint = (): void => setIsPrinting(false);

  React.useEffect(() => {
    window.addEventListener('beforeprint', onBeforePrint);
    window.addEventListener('afterprint', onAfterPrint);
    return () => {
      window.removeEventListener('beforeprint', onBeforePrint);
      window.removeEventListener('afterprint', onAfterPrint);
    };
  });

  return isPrinting;
};
